import { Button, CircularProgress } from '@mui/material';

const AppButton = ({
  loading = false,
  fullWidth = false,
  size = 'medium',
  children,
  disabled,
  sx,
  variant = 'primary',
  ...props
}) => {
  return (
    <Button
      {...props}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      variant={variant}
      size={size}
      sx={sx}
    >
      {loading ? (
        <CircularProgress color="inherit" size={size === 'small' ? 16 : 20} thickness={5} />
      ) : (
        children
      )}
    </Button>
  );
};

export default AppButton;
